import { render, staticRenderFns } from "./SelectProductTypeCreate.vue?vue&type=template&id=3821fae3&scoped=true&"
import script from "./SelectProductTypeCreate.vue?vue&type=script&lang=js&"
export * from "./SelectProductTypeCreate.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductTypeCreate.vue?vue&type=style&index=0&id=3821fae3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821fae3",
  null
  
)

export default component.exports